import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import classNames from "classnames";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import get from "lodash/get";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";

import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import ReactPhoneInput from "react-phone-input-2";
import { connect } from "react-redux";
import { instance } from "../../../Actions/AxiosInstance";
import celebration from "../../../Assets/Icons/Celebrate/celebrate-16px.svg";
import employee from "../../../Assets/Icons/Employees/employees-16px.svg";
import mobile from "../../../Assets/Icons/Mobile/mobile-16px.svg";
import probation from "../../../Assets/Icons/Probation/probation-16px.svg";
import user from "../../../Assets/Icons/User/user-16px.svg";
import check from "../../../Assets/Svg/check.svg";
import invite from "../../../Assets/Svg/invite.svg";
import rightarrow from "../../../Assets/Svg/right-arrow-blue.svg";
import TabContainer from "../../../Component/Common/TabContainer";
import DrawerHeader from "../../../Component/Headers/drawerHeader";
import LabelIcon from "../../../Component/Labels/LabelIcon";
import TextField from "../../../Component/Material-ui/TextField";
import { getFormattedDate, getFormattedImageLink } from "../../../Utils";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  padding40: {
    padding: 0,
  },
  drawerPaper: {
    width: "30%",
  },
});

class HrisDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      agecount: [],
      agename: [],
      sexcount: [],
      sexname: [],
      upcomingEvents: [],
      devices: [],
      probationandExit: [],
      joining: "",
      joining1: "",
      exits: "",
      open: false,
      DrawerOpen: false,
      right: false,
      value: 0,
      invited0: false,
      invited1: false,
      recentJoinees: [],
      empdata: [
        {
          firstname: "",
          middlename: null,
          lastname: "",
          emailid: "",
          primarymobile: "",
          callingcode: "",
          mobile: "",
          isEmailtrue: false,
        },
        {
          firstname: "",
          middlename: null,
          lastname: "",
          emailid: "",
          primarymobile: "",
          callingcode: "",
          mobile: "",
          isEmailtrue: false,
        },
        {
          firstname: "",
          middlename: null,
          lastname: "",
          emailid: "",
          primarymobile: "",
          callingcode: "",
          mobile: "",
          isEmailtrue: false,
        },
      ],
    };
    this.openDilogGrid = this.openDilogGrid.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.OnPhoneChange = this.OnPhoneChange.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.sendDetails = this.sendDetails.bind(this);
    this.handleClickAway = this.handleClickAway.bind(this);
  }

  componentDidMount() {
    const masterprofileid = get(
      this.props,
      "AuthenticationAction.login.masterprofileid",
      "",
    );
    if (masterprofileid == 9) {
      this.getHeadCount();
      this.getDeviceUpdate();
      this.getJoineeAndExitCount();
      this.getJoineeAndExitCount1();
      this.getProbationandExit();
      // this.getUpcomingEvent();
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getHeadCount() {
    instance
      .post("hrisdashboard/headcount")
      .then((result) => {
        this.setState({
          agecount: result.data.result[0].agegroup.map((age) => age.headcount),
          agename: result.data.result[0].agegroup.map(
            (age) => `${age.agegroup} yr`,
          ),
          sexcount: result.data.result[0].sexgroup.map((sex) => sex.headcount),
          sexname: result.data.result[0].sexgroup.map((sex) => sex.gendername),
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getDeviceUpdate() {
    instance
      .post("hrisdashboard/deviceupdate")
      .then((result) => {
        this.setState({
          devices: result.data.result,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getJoineeAndExitCount() {
    const data = {
      lastdays: 7,
    };
    instance
      .post("hrisdashboard/joiningandexitcount", data)
      .then((result) => {
        this.setState({
          joining: result.data.result[0].joining,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getJoineeAndExitCount1() {
    instance
      .post("hrisdashboard/joiningandexitcount")
      .then((result) => {
        this.setState({
          joining1: result.data.result[0].joining,
          exits: result.data.result[0].exits,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getUpcomingEvent() {
    instance
      .post("hrisdashboard/upcomingevent")
      .then((result) => {
        const upcomingEvents = [
          ...(result.data.result[0].birthday &&
            result.data.result[0].birthday.map((hol) => ({
              ...hol,
              birthday: true,
              work: false,
              mrg: false,
            }))),
          ...(result.data.result[0].workanniversary &&
            result.data.result[0].workanniversary.map((hol) => ({
              ...hol,
              birthday: false,
              work: true,
              mrg: false,
            }))),
          ...(result.data.result[0].marriageanniversary &&
            result.data.result[0].marriageanniversary.map((hol) => ({
              ...hol,
              birthday: false,
              work: false,
              mrg: true,
            }))),
        ];

        this.setState({
          upcomingEvents,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getProbationandExit() {
    instance
      .post("hrisdashboard/probationandexit")
      .then((result) => {
        const probationandExit = [
          ...(result.data.result[0].probation &&
            result.data.result[0].probation.map((hol) => ({
              ...hol,
              probation: true,
              exit: false,
            }))),
          ...(result.data.result[0].exits &&
            result.data.result[0].exits.map((hol) => ({
              ...hol,
              probation: false,
              exit: true,
            }))),
        ];

        this.setState({
          probationandExit,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getRecentJoinees() {
    const data = {
      isjoining: true,
      isexits: false,
      lastdays: 7,
      offset: this.state.offset,
      limit: this.state.limit,
    };
    instance
      .post("hrisdashboard/joiningandexitemployeelist", data)
      .then((result) => {
        const recentJoinees = [
          ...(result.data.result[0].joining && result.data.result[0].joining),
        ];
        this.setState({
          recentJoinees,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  openDilogGrid() {
    this.setState({
      open: true,
    });
  }

  handleClose() {
    this.setState({
      open: false,
    });
  }

  openDrawer() {
    this.setState(
      {
        DrawerOpen: true,
      },
      () => {
        this.getRecentJoinees();
      },
    );
  }

  handleClickAway() {
    this.setState({
      DrawerOpen: false,
    });
  }

  OnTabChange = (event, value) => {
    this.setState({ value });
  };

  setTabValue(value) {
    this.setState({ value });
  }

  OnPhoneChange(index, field, value) {
    const { empdata } = this.state;
    if (empdata[index]) {
      empdata[index].callingcode = value.dialCode;
      empdata[index].mobile = field;
    }
    field = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    const no = field.replace(value.dialCode, "");
    const x = no.trim();
    empdata[index].primarymobile = x;
    this.setState({ empdata });
  }

  handleChange(name, e, index) {
    const { empdata } = this.state;
    empdata[index][name] = e;
    this.setState({
      empdata,
    });
  }

  validateEmail(value, index) {
    const { empdata } = this.state;
    const currentemail = value;
    if (currentemail != "") {
      if (
        /^\w+([\.-]?\w+)*([+]{0,1}\w+){0,1}@\w+([\.-]?\w+)*(\.\w{2,15})+$/.test(
          currentemail,
        )
      ) {
        const x = empdata.find(
          (email, index1) => index != index1 && email.emailid == currentemail,
        );
        if (x) {
          this.props.enqueueSnackbar("Please enter unique email ID", {
            variant: "error",
          });
          empdata[index].isEmailtrue = false;
        } else {
          empdata[index].isEmailtrue = true;
        }
        this.setState({ empdata });
      } else {
        empdata[index].isEmailtrue = false;
        this.setState({ empdata });
        this.props.enqueueSnackbar("Please enter valid email ID", {
          variant: "error",
        });
      }
    } else {
      this.props.enqueueSnackbar("Please fill all the required fileds", {
        variant: "error",
      });
    }
  }

  sendDetails() {
    const employeedetails = [];
    if (this.state.value == 0) {
      this.state.empdata.forEach((item) => {
        if (item.firstname && item.lastname && item.isEmailtrue) {
          const object = {
            firstname: item.firstname,
            lastname: item.lastname,
            middlename: null,
            primarymobile: item.primarymobile,
            callingcode: item.callingcode,
            emailid: item.emailid,
          };
          employeedetails.push(object);
        }
      });
    } else {
      this.state.empdata.forEach((item) => {
        if (item.firstname && item.lastname && item.primarymobile) {
          const object = {
            firstname: item.firstname,
            lastname: item.lastname,
            middlename: null,
            primarymobile: item.primarymobile,
            callingcode: item.callingcode,
            emailid: item.emailid,
          };
          employeedetails.push(object);
        }
      });
    }

    const data = {
      employeedata: employeedetails,
      issms: this.state.value == 0 ? false : true,
    };
    console.log("data: ", data);
    const URL = `account/prospectemployee/${get(
      this.props,
      "AuthenticationAction.login.subscriptionid",
      "",
    )}`;

    if (employeedetails.length > 0) {
      instance
        .post(URL, data)
        .then(() => {
          this.props.enqueueSnackbar("Invite Sent Succesfully", {
            variant: "success",
          });
          if (this.state.value == 1) {
            this.setState({
              invited1: true,
              empdata: [
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
              ],
            });
          } else {
            this.setState({
              invited0: true,
              empdata: [
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
                {
                  firstname: "",
                  middlename: null,
                  lastname: "",
                  emailid: "",
                  primarymobile: "",
                  callingcode: "",
                  mobile: "",
                  isEmailtrue: false,
                },
              ],
            });
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.props.enqueueSnackbar("Please fill all the required fileds", {
        variant: "error",
      });
    }
  }

  render() {
    const { value, invited0, invited1, agename, agecount } = this.state;
    const { classes } = this.props;
    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.HRIS.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            <Grid container>
              <Grid
                item
                xs={12}
                md={8}
                sm={12}
                style={{ padding: "0px 12px 0px 24px" }}
              >
                <div className="margin-bottom-24">
                  <LabelIcon label="Head count stats" img={employee} />
                  <Paper
                    style={{
                      height: 196,
                      position: "relative",
                    }}
                  >
                    <div style={{ padding: "0px 16px" }}>
                      <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                          <div className="doughnut-chart">
                            {agename && agecount && (
                              <Doughnut
                                data={{
                                  labels: this.state.agename,
                                  datasets: [
                                    {
                                      label: "Age group",
                                      data: this.state.agecount,
                                      backgroundColor: [
                                        "#f7b596",
                                        "#b596f7",
                                        "#f7dc96",
                                        "#96acf7",
                                        "#96f7df",
                                        "#f7dc96",
                                        "#d0f796",
                                        "#e0f7fa",
                                        "#eceff1",
                                        "#efebe9",
                                        "#d7ccc8",
                                        "#cfd8dc",
                                        "#e3f2fd",
                                        "#fff9c4",
                                        "#b2dfdb",
                                        "#c8e6c9",
                                        "#e0e0e0",
                                        "#ffe0b2",
                                        "#f3e5f5",
                                      ],
                                    },
                                  ],
                                }}
                                width="150px"
                                height="100px"
                                options={{
                                  rotation: 100,
                                  animation: {
                                    animateRotate: true,
                                  },
                                  tooltips: {
                                    footerFontSize: 18,
                                    titleFontSize: 18,
                                    bodyFontSize: 18,
                                  },
                                  title: {
                                    display: true,
                                    text: "Age group",
                                    position: "top",
                                    fontSize: 20,
                                    fontFamily: "Muli",
                                  },
                                  legend: {
                                    display: true,
                                    position: "right",
                                    fullWidth: false,
                                    labels: {
                                      fontSize: 16,
                                    },
                                  },
                                }}
                              />
                            )}
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <div className="bar-chart">
                            <Bar
                              data={{
                                labels: this.state.sexname,
                                datasets: [
                                  {
                                    label: "",
                                    data: this.state.sexcount,
                                    backgroundColor: [
                                      "#f7b596",
                                      "#b596f7",
                                      "#f7dc96",
                                      "#96acf7",
                                      "#96f7df",
                                      "#f7dc96",
                                      "#d0f796",
                                      "#e0f7fa",
                                      "#eceff1",
                                      "#efebe9",
                                      "#d7ccc8",
                                      "#cfd8dc",
                                      "#e3f2fd",
                                      "#fff9c4",
                                      "#b2dfdb",
                                      "#c8e6c9",
                                      "#e0e0e0",
                                      "#ffe0b2",
                                      "#f3e5f5",
                                    ],
                                  },
                                ],
                              }}
                              width="150px"
                              height="100px"
                              options={{
                                rotation: 100,
                                animation: {
                                  animateRotate: true,
                                },
                                tooltips: {
                                  footerFontSize: 18,
                                  titleFontSize: 18,
                                  bodyFontSize: 18,
                                },
                                scales: {
                                  yAxes: [
                                    {
                                      ticks: {
                                        fontSize: 16,
                                        beginAtZero: true,
                                        userCallback(label, index, labels) {
                                          if (Math.floor(label) === label) {
                                            return label;
                                          }
                                        },
                                      },
                                    },
                                  ],
                                  xAxes: [
                                    {
                                      ticks: {
                                        fontSize: 16,
                                      },
                                    },
                                  ],
                                },
                                title: {
                                  display: true,
                                  text: "Gender",
                                  position: "top",
                                  fontSize: 20,
                                  fontFamily: "Muli",
                                },
                                legend: {
                                  display: false,
                                  position: "",
                                  fullWidth: false,
                                },
                              }}
                            />
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Paper>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                sm={12}
                style={{ padding: "0px 12px 0px 12px" }}
              >
                <div className="margin-bottom-20">
                  <LabelIcon label="Recent joiners in last week" img={user} />
                  <Paper
                    className="padding16 cursurpointer"
                    style={{
                      height: 42,
                    }}
                    onClick={this.openDrawer}
                  >
                    <div className="floatleft cursurpointer margin-top-8">
                      <p className="t-bold large-text-dark-secondary cursurpointer">
                        {this.state.joining ? this.state.joining : "0"} People
                      </p>
                    </div>
                    <div className="floatright cursurpointer margin-top-8">
                      <span style={{ fontSize: 26 }}>🙋🏻‍♂️</span>
                    </div>
                  </Paper>
                </div>
                <div className="margin-bottom-24">
                  <LabelIcon label="Expanding your team?" img={invite} />
                  <Paper
                    className="padding16"
                    style={{
                      height: 42,
                      cursor: "pointer",
                    }}
                    onClick={this.openDilogGrid}
                  >
                    <div className="floatleft cursurpointer margin-top-8">
                      <p className="normal-blue-dark">Invite team member</p>
                    </div>
                    <div className="floatright cursurpointer margin-top-8">
                      <img
                        className="cursurpointer"
                        src={rightarrow}
                        style={{ fontSize: 26 }}
                      ></img>
                    </div>
                  </Paper>
                </div>
              </Grid>
            </Grid>
            <Grid container>
              {this.state.upcomingEvents.length > 0 && (
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={12}
                  style={{ padding: "0px 12px 0px 24px" }}
                >
                  <div className="margin-bottom-24">
                    <LabelIcon
                      label="Celebration for the next 30 days"
                      img={celebration}
                    />
                    <Paper
                      className="padding16 thin-scroll"
                      style={{
                        height: "65vh",
                        position: "relative",
                        overflowY: "auto",
                      }}
                    >
                      {this.state.upcomingEvents.length > 0 ? (
                        this.state.upcomingEvents.map((event) => (
                          <div style={{ padding: "8px 16px" }}>
                            <Grid
                              container
                              style={{ borderBottom: "1px solid #edf5fd" }}
                            >
                              <Grid item xs={12} md={1} sm={12}>
                                <p className="t-12 margin-top-2">
                                  {event.birthday
                                    ? "🎁"
                                    : event.work
                                    ? "💻"
                                    : "❣"}
                                </p>
                              </Grid>
                              <Grid item xs={12} md={5} sm={12}>
                                <p className="small-dark-secondary">
                                  {event.birthday
                                    ? getFormattedDate(event.dob)
                                    : event.work
                                    ? getFormattedDate(event.doj)
                                    : getFormattedDate(
                                        event.marriageanniversarydate,
                                      )}
                                </p>
                              </Grid>
                              <Grid item xs={12} md={6} sm={12}>
                                <p className="small-dark-secondary text-align-right">
                                  {event.fullname}
                                </p>
                              </Grid>
                            </Grid>
                          </div>
                        ))
                      ) : (
                        <div
                          style={{
                            fontSize: 14,
                            textAlign: "center",
                            marginTop: 20,
                          }}
                        >
                          No Records Found
                        </div>
                      )}
                    </Paper>
                  </div>
                </Grid>
              )}
              {this.state.devices.length > 0 && (
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={12}
                  style={{ padding: "0px 12px 0px 12px" }}
                >
                  <div>
                    <LabelIcon
                      label={`Changed mobile devices (${this.state.devices.length})`}
                      img={mobile}
                    />
                    <Paper
                      className="thin-scroll"
                      style={{
                        height: "70vh",
                        position: "relative",
                        overflowY: "auto",
                      }}
                    >
                      {this.state.devices.length > 0 ? (
                        this.state.devices.map((device) => (
                          <div style={{ padding: "8px 16px" }}>
                            <Grid
                              container
                              style={{
                                borderBottom: "1px solid #edf5fd",
                                paddingBottom: 4,
                              }}
                            >
                              <Grid item xs={12} md={1} sm={12}>
                                <p className="t-12 margin-top-2">📲</p>
                              </Grid>
                              <Grid item xs={12} md={11} sm={12}>
                                <p className="small-dark-secondary">
                                  {device.empfullname}
                                </p>
                                <p className="extra-small-dark-disabled">
                                  {device.devicebrand ? device.devicebrand : ""}{" "}
                                  {device.devicemodel ? device.devicemodel : ""}
                                </p>
                              </Grid>
                            </Grid>
                          </div>
                        ))
                      ) : (
                        <div className="text-align-center margin-top-30">
                          Not records found
                        </div>
                      )}
                    </Paper>
                  </div>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                md={4}
                sm={12}
                style={{ padding: "0px 12px 0px 12px" }}
              >
                {this.state.probationandExit.length > 0 && (
                  <div className="margin-bottom-24">
                    <LabelIcon
                      label={`Confirmations & Exits this week (${this.state.probationandExit.length})`}
                      img={probation}
                    />
                    <Paper
                      className="thin-scroll"
                      style={{
                        height: 200,
                        overflowY: "auto",
                      }}
                    >
                      {this.state.probationandExit.length > 0 ? (
                        this.state.probationandExit.map((data) => (
                          <div style={{ padding: "8px 16px" }}>
                            <Grid
                              container
                              style={{
                                borderBottom: "1px solid #edf5fd",
                                paddingBottom: 4,
                              }}
                            >
                              <Grid item xs={12} md={1} sm={12}>
                                <p className="t-12 margin-top-2">
                                  {data.probation ? "🔜" : "👀"}
                                </p>
                              </Grid>
                              <Grid item xs={12} md={11} sm={12}>
                                <p className="small-dark-secondary">
                                  {data.fullname}
                                </p>
                                <p className="extra-small-dark-disabled">
                                  {data.probation
                                    ? `Probation is ending on ${getFormattedDate(
                                        data.dateofprobation,
                                      )}`
                                    : `Leaving on ${getFormattedDate(
                                        data.expectedresignationdate,
                                      )}`}
                                </p>
                              </Grid>
                            </Grid>
                          </div>
                        ))
                      ) : (
                        <div className="text-align-center margin-top-30">
                          Not records found
                        </div>
                      )}
                    </Paper>
                  </div>
                )}
                {/* <div>
                  <LabelIcon label="Past entries and exits" img={probation} />
                  <Paper
                    style={{
                      // height: 200,
                      position: "relative",
                    }}
                  >
                    <div style={{ padding: "8px 16px" }}>
                      <Grid container>
                        <Grid item xs={12} md={12} sm={12}>
                          <div className="bar-chart-joining">
                            <Bar
                              data={{
                                labels: ["Joining", "Exit"],
                                datasets: [
                                  {
                                    label: "",
                                    data: [
                                      this.state.joining1
                                        ? this.state.joining1
                                        : 0,
                                      this.state.exits ? this.state.exits : 0,
                                    ],
                                    backgroundColor: [
                                      "#f7b596",
                                      "#b596f7",
                                      "#f7dc96",
                                      "#96acf7",
                                      "#96f7df",
                                      "#f7dc96",
                                      "#d0f796",
                                      "#e0f7fa",
                                      "#eceff1",
                                      "#efebe9",
                                      "#d7ccc8",
                                      "#cfd8dc",
                                      "#e3f2fd",
                                      "#fff9c4",
                                      "#b2dfdb",
                                      "#c8e6c9",
                                      "#e0e0e0",
                                      "#ffe0b2",
                                      "#f3e5f5",
                                    ],
                                  },
                                ],
                              }}
                              width="150px"
                              height="100px"
                              options={{
                                rotation: 100,
                                animation: {
                                  animateRotate: true,
                                },
                                tooltips: {
                                  footerFontSize: 16,
                                  titleFontSize: 16,
                                  bodyFontSize: 16,
                                },
                                scales: {
                                  yAxes: [
                                    {
                                      ticks: {
                                        beginAtZero: true,
                                        userCallback(label, index, labels) {
                                          if (Math.floor(label) === label) {
                                            return label;
                                          }
                                        },
                                      },
                                    },
                                  ],
                                  xAxes: [
                                    {
                                      ticks: {
                                        beginAtZero: true,
                                        fontSize: 16,
                                      },
                                    },
                                  ],
                                },
                                title: {
                                  display: true,
                                  text: "Joining & Exit",
                                  position: "top",
                                  fontSize: 20,
                                },
                                legend: {
                                  display: false,
                                  position: "",
                                  fullWidth: false,
                                  labels: {
                                    fontSize: 16,
                                  },
                                },
                              }}
                            />
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Paper>
                </div> */}
              </Grid>
            </Grid>
            <Dialog
              fullWidth={true}
              maxWidth="sm"
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="max-width-dialog-title"
            >
              <DialogTitle
                id="max-width-dialog-title"
                className="large-text-dark t-bold"
              >
                Invite your team members
              </DialogTitle>
              <DialogContent>
                <div
                  style={{
                    height: "300px",
                    width: "100%",
                  }}
                >
                  <div
                    className="common-menubar-header"
                    style={{ position: "unset" }}
                  >
                    <Tabs
                      value={value}
                      onChange={this.OnTabChange}
                      indicatorColor="#fff"
                      textColor="primary"
                    >
                      <Tab
                        label="Invite via email"
                        className={`tabheading invite-label ${
                          this.state.value == 0
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                      <Tab
                        label="Invite via SMS"
                        className={`tabheading invite-label ${
                          this.state.value == 1
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                    </Tabs>
                    <div className="tab-border"></div>
                  </div>
                  {value === 0 && (
                    <TabContainer>
                      {!invited0 ? (
                        <Grid
                          container
                          className="margin-top-24"
                          setTabValue={this.setTabValue.bind(this)}
                        >
                          {this.state.empdata.map((emp, index) => (
                            <Grid container>
                              <Grid
                                item
                                xs={12}
                                md={3}
                                sm={3}
                                style={{ paddingRight: 4, paddingBottom: 8 }}
                              >
                                <p className="input-label">Enter first name</p>
                                <TextField
                                  className="formula-input"
                                  variant="outlined"
                                  placeholder="Enter name"
                                  onChange={(e) =>
                                    this.handleChange(
                                      "firstname",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  value={emp.firstName}
                                  maxLength="100"
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                md={3}
                                sm={3}
                                style={{ paddingLeft: 4, paddingBottom: 8 }}
                              >
                                <p className="input-label">Enter last name</p>
                                <TextField
                                  className="formula-input"
                                  variant="outlined"
                                  placeholder="Enter name"
                                  onChange={(e) =>
                                    this.handleChange(
                                      "lastname",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  value={emp.lastName}
                                  maxLength="100"
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                md={6}
                                sm={6}
                                style={{ paddingLeft: 8, paddingBottom: 8 }}
                              >
                                <p className="input-label">
                                  Enter email address
                                </p>
                                <TextField
                                  className="formula-input"
                                  variant="outlined"
                                  type="email"
                                  placeholder="Enter email address"
                                  onBlur={(e) =>
                                    this.validateEmail(e.target.value, index)
                                  }
                                  onChange={(e) =>
                                    this.handleChange(
                                      "emailid",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  value={emp.emailId}
                                  maxLength="100"
                                />
                              </Grid>
                            </Grid>
                          ))}
                        </Grid>
                      ) : (
                        <Grid
                          container
                          style={{
                            position: "relative",
                            top: "50%",
                            transform: "translateY(30%)",
                            textAlign: "center",
                            height: 180,
                          }}
                        >
                          <Grid item xs={12} md={12} sm={12}>
                            <div className="margin-bottom-24">
                              <img src={check}></img>
                            </div>
                            <p className="large-text-dark">
                              You have successfully invited your team members.
                            </p>
                            <div style={{ textAlign: "center", marginTop: 24 }}>
                              <Button
                                className="btn btn-primary-md-blue"
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  this.setState({ invited0: false })
                                }
                              >
                                Invite more
                              </Button>
                            </div>
                          </Grid>
                        </Grid>
                      )}
                    </TabContainer>
                  )}
                  {value === 1 && (
                    <TabContainer>
                      {!invited1 ? (
                        <Grid
                          container
                          className="margin-top-24"
                          setTabValue={this.setTabValue.bind(this)}
                        >
                          {this.state.empdata.map((emp, index) => (
                            <Grid container>
                              <Grid
                                item
                                xs={12}
                                md={3}
                                sm={3}
                                style={{ paddingRight: 4, paddingBottom: 8 }}
                              >
                                <p className="input-label">Enter first name</p>
                                <TextField
                                  className="formula-input"
                                  variant="outlined"
                                  placeholder="Enter name"
                                  onChange={(e) =>
                                    this.handleChange(
                                      "firstname",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  value={emp.firstName}
                                  maxLength="100"
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                md={3}
                                sm={3}
                                style={{ paddingLeft: 4, paddingBottom: 8 }}
                              >
                                <p className="input-label">Enter last name</p>
                                <TextField
                                  className="formula-input"
                                  variant="outlined"
                                  placeholder="Enter name"
                                  onChange={(e) =>
                                    this.handleChange(
                                      "lastname",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  value={emp.lastName}
                                  maxLength="100"
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                md={6}
                                sm={6}
                                style={{ paddingLeft: 8, paddingBottom: 8 }}
                              >
                                <p className="input-label">
                                  Enter phone number
                                </p>
                                <ReactPhoneInput
                                  defaultCountry={"in"}
                                  style={{ marginTop: 0 }}
                                  className="margin-top-0"
                                  onChange={(field, value) =>
                                    this.OnPhoneChange(index, field, value)
                                  }
                                  countryCodeEditable={true}
                                  value={emp.mobile}
                                  InputProps={{ maxLength: 15, minLength: 5 }}
                                />
                              </Grid>
                            </Grid>
                          ))}
                        </Grid>
                      ) : (
                        <Grid
                          container
                          style={{
                            position: "relative",
                            top: "50%",
                            transform: "translateY(30%)",
                            textAlign: "center",
                            height: 180,
                          }}
                        >
                          <Grid item xs={12} md={12} sm={12}>
                            <div className="margin-bottom-24">
                              <img src={check}></img>
                            </div>
                            <p className="large-text-dark">
                              You have successfully invited your team members.
                            </p>
                            <div style={{ textAlign: "center", marginTop: 24 }}>
                              <Button
                                className="btn btn-primary-md-blue"
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  this.setState({ invited1: false })
                                }
                              >
                                Invite more
                              </Button>
                            </div>
                          </Grid>
                        </Grid>
                      )}
                    </TabContainer>
                  )}
                </div>
              </DialogContent>
              {this.state.value == 0 && !this.state.invited0 && (
                <DialogActions style={{ margin: 16 }}>
                  <Button
                    onClick={this.handleClose}
                    className="btn btn-secondary-md-blue"
                    color="primary"
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-primary-md-blue"
                    variant="contained"
                    color="primary"
                    onClick={this.sendDetails}
                  >
                    Invite
                  </Button>
                </DialogActions>
              )}
              {this.state.value == 1 && !this.state.invited1 && (
                <DialogActions style={{ margin: 16 }}>
                  <Button
                    onClick={this.handleClose}
                    className="btn btn-secondary-md-blue"
                    color="primary"
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-primary-md-blue"
                    variant="contained"
                    color="primary"
                    onClick={this.sendDetails}
                  >
                    Invite
                  </Button>
                </DialogActions>
              )}
              {this.state.value == 0 && this.state.invited0 && (
                <DialogActions style={{ margin: 16 }}></DialogActions>
              )}
              {this.state.value == 1 && this.state.invited1 && (
                <DialogActions style={{ margin: 16 }}></DialogActions>
              )}
            </Dialog>
            <Drawer
              anchor="right"
              open={this.state.DrawerOpen}
              onClose={this.handleClickAway}
              style={{ padding: 40 }}
              classes={{
                paper: classNames(
                  classes.drawerPaper,
                  "planner-drawer padding15",
                ),
              }}
            >
              <DrawerHeader
                header="Recent joiners in last 7 days"
                isbackarrow={false}
                closeDrawer={this.handleClickAway}
              />
              {this.state.recentJoinees.map((emp) => (
                <div>
                  <div className="position-rel">
                    <div className="cursour-pointer width100">
                      <div className="floatleft">
                        <img
                          src={getFormattedImageLink(emp.imagepath)}
                          className="dir-profile-img margin-top-3"
                          height="83"
                        ></img>
                      </div>
                      <div className="floatleft margin-top-16 margin-left-16">
                        <p className="small-dark-secondary t-bold">
                          {emp.fullname}
                        </p>
                        <p className="extra-small-dark-disabled">
                          {emp.designationname}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Drawer>
          </div>
        )}
      </div>
    );
  }
}

HrisDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  refreshProfileInfoReducer: state.refreshProfileInfoReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(HrisDashboard)),
);
